// extracted by mini-css-extract-plugin
module.exports = {"player":"_4yTIq","player-loading":"_3vqIB","playerLoading":"_3vqIB"};